/* eslint-disable no-unused-vars */
import * as React from "react";
/* eslint-enable no-unused-vars */
import { connect } from "react-redux";
import { IApplicationState } from "../../models/store/storeTypes";
import * as storeEffects from "../../models/store/storeEffects";
import { IEventPageOwnProps, IEventPageStateProps, IEventPageDispatchProps, EventPage } from "../../components/event/EventPage";
import { ITypedOption } from "../../models/common/typedOption";
import { EventThunkDispatch, getEventPage } from "source/models/store/event";

export function mapStateToProps(applicationState: IApplicationState, ownProps: IEventPageOwnProps): IEventPageStateProps {
    if (!applicationState || !applicationState.front) {
        return {
            appState: null,
            dataId: -1,
            eventPage: null,
            list: null
        };
    }
    const event = applicationState.event;
    return {
        appState: applicationState.session,
        dataId: event.page.dataId,
        eventPage: event.page.eventPage,
        list: event.list
    };
}

export function mapDispatchToProps(dispatch: EventThunkDispatch): IEventPageDispatchProps {
    return {
        onGetEventPage: () => dispatch(getEventPage()),
        onLogout: () => dispatch(storeEffects.logout()),
        onSetCulture: (culture: string) => dispatch(storeEffects.setCulture(culture)),
        onSaveUserParameters: (parameters: ITypedOption[]) => dispatch(storeEffects.saveUserParameters(parameters)),
        onRefreshSessionState: () => dispatch(storeEffects.refreshSessionState()),
    };
}

export default connect<IEventPageStateProps, IEventPageDispatchProps, IEventPageOwnProps>(mapStateToProps, mapDispatchToProps)(EventPage);